import Container from  './container'
import Main from './main'
import Header from './header'
import Footer from './footer'
import Silder from './silder'
import './layout.less'

Container.install = function (Vue, options = {}) {
  Vue.component(options.containerName || Container.name, Container)
  Vue.component(options.mainName || Main.name, Main)
  Vue.component(options.headerName || Header.name, Header)
  Vue.component(options.footerName || Footer.name, Footer)
  Vue.component(options.silderName || Silder.name, Silder)
}

export const MContainer = Container
export const MMain = Main
export const MHeader = Header
export const MFooter = Footer
export const MSilder = Silder

export default Container

